import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { instanceAxios } from '../../InstanceAxios';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';

/**
 * TIPO
 * 1:Mensal
 * 2:Anual
 */

function botaoAvancar(id, tipo) {
  const hj = new Date();
  if (tipo === 1) {
    return (
      <Button
        fullWidth
        variant="contained"
        href={`/atividades/mensal/${id}/${
          hj.getMonth() + 1
        }/${hj.getFullYear()}`}
      >
        SELECIONAR
      </Button>
    );
  } else {
    const hj = new Date();
    return (
      <Button
        fullWidth
        variant="contained"
        href={`/atividades/anual/${id}/${hj.getFullYear()}`}
      >
        SELECIONAR
      </Button>
    );
  }
}

function Atividades() {
  const [atividades, setAtividades] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [nome, setNome] = useState('');
  const [praca, setPraca] = useState('');
  const [tipo, setTipo] = useState(1);

  const atualizandoAtividades = async (filtro) => {
    console.log(`/atividades?praca=${filtro}`);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/atividades?praca=${filtro}`)
      .then((res) => {
        console.log(res.data);
        setAtividades(res.data);
      })
      .catch((err) => {
        console.log(err);
        setErro(true);
      });
  };

  useEffect(() => {
    const fetchAtividades = async () => {
      setLoading(true);
      atualizandoAtividades(filtro);
      setLoading(false);
    };
    fetchAtividades();
  }, [filtro]);

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: 'absolute',
      width: 800,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
      width: '80%',
      height: '80%',
      overflow: 'auto',
    },
  }));

  const buscarFiltro = (textoBusca) => {
    setFiltro(textoBusca);
  };

  const salvarAtividades = async () => {
    setLoading(true);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/atividades`, {
        nome,
        praca,
        tipo,
      })
      .then((res) => {
        setSucesso(true);
        setOpenModal(false);
        atualizandoAtividades(filtro);
      })
      .catch((err) => {
        setErro(true);
        setOpenModal(false);
      });
    setLoading(false);
  };

  const clickAlert = () => {
    setSucesso(false);
    setErro(false);
  };

  const classes = useStyles();

  return (
    <div style={{ margin: 20 }}>
      <Collapse in={erro}>
        <Alert severity="error" onClick={clickAlert}>
          Erro Ao Criar/Acessar atividade
        </Alert>
      </Collapse>
      <Collapse in={sucesso}>
        <Alert severity="success" onClick={clickAlert}>
          Atividade Criada com sucesso
        </Alert>
      </Collapse>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <div className={classes.paper}>
          <Grid container spacing={1} justify="left" alignItems="left">
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <h2>Nova Atividade</h2>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                label="Nome"
                value={nome}
                fullWidth
                onChange={(data) => setNome(data.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Praça"
                value={praca}
                fullWidth
                onChange={(data) => setPraca(data.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label="Tipo"
                value={tipo}
                fullWidth
                select
                onChange={(data) => setTipo(data.target.value)}
              >
                <MenuItem value={1}>Mensal</MenuItem>
                <MenuItem value={2}>Anual</MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div align="right" style={{ paddingTop: '5%' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={salvarAtividades}
                startIcon={<SaveIcon />}
              >
                Salvar
              </Button>
            </div>
          </Grid>
        </div>
      </Modal>

      <Grid container>
        <Grid item xs={6}>
          <Button
            variant="contained"
            style={{
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
            }}
            onClick={() => setOpenModal(true)}
            startIcon={<AddIcon />}
          >
            Novo
          </Button>
        </Grid>
        <Grid item xs={6}>
          <div align="right">
            <TextField
              id="busca"
              label="Praça"
              value={filtro}
              onChange={(event) => buscarFiltro(event.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </Grid>
      </Grid>
      <Container maxWidth="md" component="main" style={{ paddingTop: '2%' }}>
        <Grid container spacing={5} alignItems="flex-end">
          {atividades.map((a) => (
            <Grid item key={a.id} lg={4} md={4} sm={12} xl={12} xs={12}>
              <Card>
                <CardHeader
                  title={a.nome}
                  subheader={`${a.praca}-${a.tipo === 1 ? 'Mensal' : 'Anual'}`}
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{ align: 'center' }}
                />
                <CardContent />
                <CardActions>{botaoAvancar(a.id, a.tipo)}</CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}

export default Atividades;
